<mat-form-field appearance="outline" class="flex-1">
  <mat-label>{{label()}}</mat-label>
  <div matSuffix="" class="flex items-center">
    @if (isLoadingContacts === true) {
      <mat-spinner diameter="14" class="mx2"></mat-spinner>
    }
  </div>
  <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="contactAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
  <mat-autocomplete autoActiveFirstOption="" #contactAutoComplete="matAutocomplete" [displayWith]="displayWithCustomer">
    @if (required() === false) {
      <mat-option [value]="null">
        <span translate="">None</span>
      </mat-option>
    }
    @for (contact of contactsFiltered; track contact) {
      <mat-option [value]="contact">
        @if (contact.type == 'Person') {
          <mat-icon class="icon-small mr1">person_outline</mat-icon>
        }
        {{contact.name}} @if (contact.email) {
        <span class="gray">({{contact.email}})</span>
      }
    </mat-option>
  }
</mat-autocomplete>
</mat-form-field>
